module.exports = __webpack_public_path__ + "img/tintuc18.228230ac.png";